import { FunctionComponent } from "react";

import {
  HeadersTable,
  HeadersTableWrapper,
  TableHeader,
  TableValue,
} from "@src/modules/DicomViewer/DicomHeadersModal/DicomHeadersTable/DicomHeadersTable.components";
import { DicomHeader } from "@src/modules/DicomViewer/DicomHeadersModal/hooks/useDicomHeaders";

interface Props {
  headers: DicomHeader[];
}

const DicomHeadersTable: FunctionComponent<Props> = ({ headers }) => (
  <HeadersTableWrapper>
    <HeadersTable>
      <thead>
        <tr>
          <TableHeader>Group-element</TableHeader>
          <TableHeader>Tag Name</TableHeader>
          <TableHeader>VR</TableHeader>
          <TableHeader>Length</TableHeader>
          <TableHeader>Value</TableHeader>
        </tr>
      </thead>
      <tbody>
        {headers.map((header) => (
          <tr key={`${header.tag}-${header.value}`}>
            <TableValue>{header.tag}</TableValue>
            <TableValue>{header.description}</TableValue>
            <TableValue>{header.vr}</TableValue>
            <TableValue>{header.length}</TableValue>
            <TableValue>{header.value}</TableValue>
          </tr>
        ))}
      </tbody>
    </HeadersTable>
  </HeadersTableWrapper>
);

export default DicomHeadersTable;
